import * as Yup from "yup";

const validationSchema = Yup.object({
    financialYear: Yup.string().max(7,'Maximum limit is 7')
        .required("Financial Year is required.")
});

export { validationSchema };
